import { apiClient } from "./apiClient";
import { endpoints } from "./endpoints";
import { tokenTransport } from "./tokenTransport";
import type { TokenPair } from "./tokenStorage";

export interface LoginCredentials {
  email: string;
  password: string;
}

/**
 * Thin transport wrapper only - no session/token STORAGE lives here (that
 * is `tokenStorage.ts`'s exclusive job) and no session/token BUSINESS
 * LOGIC lives here either (session lifetime, revocation, and validity are
 * entirely the backend's - see `docs/security/SESSION_GUIDE.md`). This
 * module only shapes HTTP calls to the real `/api/v1/auth/*` contract and
 * returns plain results for `AuthContext` to act on.
 */
export const authService = {
  async login(credentials: LoginCredentials): Promise<TokenPair> {
    return tokenTransport.login(credentials.email, credentials.password);
  },

  async refresh(refreshToken: string): Promise<TokenPair> {
    return tokenTransport.refresh(refreshToken);
  },

  async logout(): Promise<void> {
    // Bearer token is injected by apiClient's own request interceptor
    // from whatever is still in tokenStorage at call time - the caller
    // (AuthContext) must call this BEFORE clearing local tokens.
    await apiClient.post(endpoints.auth.logout);
  },
};
